import React from "react";


const MinusIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="1.5" viewBox="0 0 19 1.5">
            <g id="Group_630" data-name="Group 630" transform="translate(0 0.75)">
                <line id="Line_135" data-name="Line 135" y2="19" transform="translate(19) rotate(90)" fill="none" stroke="#707070" stroke-width="1.5" />
            </g>
        </svg>


    );

}

export default MinusIcon;